module.exports = __webpack_public_path__ + "img/default-star-filled-icon.a8b2d483.svg";